import React from "react";
import {List, Avatar} from "antd";
import useFetch from "hooks/fetch";
import {Blog} from "interfaces";
import {Link} from "react-router-dom";

const Lists : React.FC = () => {

    const [isLoading, datasource] = useFetch("blog", "desc", true);

    return (
        <aside className={"main-side"}>
            <div className={"section-heading"}>
                <h2>Artikel Terbaru</h2>
            </div>
            <List
                itemLayout="horizontal"
                dataSource={datasource}
                loading={isLoading}
                renderItem={(item : Blog) => {

                    let content = item.content
                        ? item.content.replace(/(<([^>]+)>)/gi, "")
                        : "";

                    return item.key ? (
                        <List.Item>
                            <List.Item.Meta
                                avatar={<Avatar shape={"square"} size={100} src={item.image.url}/>}
                                title={<Link to={`/blog/${item.key}/${item?.title?.replace(/ /g, "-")}`}>{item.title}</Link>}
                                description={content.length > 100 ? content.slice(0, 50) + "....." : content}
                            />
                        </List.Item>
                    ) : null
                }}
            />
        </aside>
    )
}

export default React.memo(Lists);